function closedPanels() {
    const panels = document.querySelectorAll(".panel--add-btn");

    if(panels.length >= 1) {
        panels.forEach((panel) => {
            panel.querySelector(".sk-panel-header").click()
        })
    }
}

export { closedPanels };